import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=6c987458&scoped=true"
import script from "./goodsCard.vue?vue&type=script&lang=js"
export * from "./goodsCard.vue?vue&type=script&lang=js"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=6c987458&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c987458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c987458')) {
      api.createRecord('6c987458', component.options)
    } else {
      api.reload('6c987458', component.options)
    }
    module.hot.accept("./goodsCard.vue?vue&type=template&id=6c987458&scoped=true", function () {
      api.rerender('6c987458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/release/goodsCard.vue"
export default component.exports